enum MomentState {
    VALID_MAIN_CONTENT_GENERAL_INFORMATION
}
interface ValidGeneralInformation {
    type: MomentState.VALID_MAIN_CONTENT_GENERAL_INFORMATION,
    isValid:boolean
}
interface State {
    isValidGeneralInformation: boolean
}
type Moments = ValidGeneralInformation

export { Moments, State, MomentState, ValidGeneralInformation }
